var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompletedReq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 54,
    height: 54,
    rx: 27,
    fill: "#F6F7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_8792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 39.5C20.5963 39.5 15 33.9037 15 27C15 20.0963 20.5963 14.5 27.5 14.5C34.4037 14.5 40 20.0963 40 27C40 33.9037 34.4037 39.5 27.5 39.5ZM27.5 37C30.1522 37 32.6957 35.9464 34.5711 34.0711C36.4464 32.1957 37.5 29.6522 37.5 27C37.5 24.3478 36.4464 21.8043 34.5711 19.9289C32.6957 18.0536 30.1522 17 27.5 17C24.8478 17 22.3043 18.0536 20.4289 19.9289C18.5536 21.8043 17.5 24.3478 17.5 27C17.5 29.6522 18.5536 32.1957 20.4289 34.0711C22.3043 35.9464 24.8478 37 27.5 37ZM26.2537 32L20.95 26.6962L22.7175 24.9288L26.2537 28.465L33.3237 21.3937L35.0925 23.1613L26.2537 32Z",
    fill: "#4361EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_8792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedReq);
export default __webpack_public_path__ + "static/media/completed-req.0f2a69c6eb7b41ac7cbf86b0ec72f08e.svg";
export { ForwardRef as ReactComponent };